export const DARK_UNDERLINED_LINK_PROPS = {
  skin: 'dark',
  weight: 'normal',
  underline: 'always'
};
export const monthlyNoteLinkProps = mobile => mobile ? DARK_UNDERLINED_LINK_PROPS : {};
//# sourceMappingURL=monthlyNoteLinkProps.js.map